import gql from 'graphql-tag';

import { cartPriceDataFields, cartPromotionDataFields } from './cart-queries';
import { fitmentVehicleAssemblyFields } from './common-fitment-queries';
import { instantPromotionFields } from './potential-promotions-fragment';

export const GET_QUOTE_DETAILS = gql`
  query getQuoteDetails($quoteToken: String!) {
    order {
      quoteByToken(token: $quoteToken) {
        totalTax {
          ...cartPriceDataFields
        }
        totalPrice {
          ...cartPriceDataFields
        }
        totalPriceWithTax {
          ...cartPriceDataFields
        }
        created
        token
        appointmentData {
          date
          rescheduleURL
          changeStoreURL
          services {
            name
            code
          }
          status
          cancellationURL
          formattedDateTime
          appointmentId
        }
        deliveryAddress {
          firstName
          lastName
          phone
          phoneType
          email
          line1
          line2
          postalCode
          town
          region {
            countryIso
            isocode
            isocodeShort
          }
          comment
        }
        fleetDetails {
          companyName
          fleetAccountNumber
        }
        transactionDetails {
          key
          value
        }
        refundType
        pointOfService {
          address {
            phone
            email
            line1
            line2
            postalCode
            town
            region {
              isocodeShort
            }
          }
          applicationType
          code
          geoPoint {
            latitude
            longitude
          }
        }
        recipientData {
          email
          firstName
          lastName
          phone
        }
        formattedDateTime
        orderType
        quoteStatus
        name
        status {
          code
          type
        }
        code
        description
        validUntil
        validUntilFormatted
        vehicleAssembly {
          ...fitmentVehicleAssemblyFields
        }
        paymentInfoList {
          id
        }
        appliedOrderPromotions {
          promotionData {
            ...cartPromotionDataFields
          }
        }
        storeFeeValues {
          name
          description
          cost {
            ...cartPriceDataFields
          }
        }
        groupEntries {
          allProductsApproved
          entryType
          entries {
            adjustments {
              code
              name
              amount {
                formattedValue
              }
            }
            promotionData {
              ...cartPromotionDataFields
            }
            product {
              brand
              code
              description
              dtatInstall
              size
              productType
              primaryImageUrl
              name
              unitName
            }
            basePrice {
              ...cartPriceDataFields
            }
            priceBeforeDiscount {
              ...cartPriceDataFields
            }
            totalPrice {
              ...cartPriceDataFields
            }
            subtotal {
              ...cartPriceDataFields
            }
            quantity
          }
        }
      }
    }
  }

  ${cartPriceDataFields}
  ${instantPromotionFields}
  ${cartPromotionDataFields}
  ${fitmentVehicleAssemblyFields}
`;
